/// <reference path="../typings/browser.d.ts" />
import { formatTimeMark } from '@deltasierra/shared';

angular.module('app').filter('timeMark', [function () {
    return function (timeMarkMs : number) : string {
        return formatTimeMark(timeMarkMs);
    };
}]);

